<div class="welcome">
    <h1 class="welcome-text" [innerHTML]="'AUTH.WELCOME' | translate"></h1>
</div>
<div class="container">
    <h2 class="titleContainer" [innerHTML]="'AUTH.TITLE' | translate"></h2>
    <div class="form-group">
        <label for="tokenInput" class="input-label">{{ 'AUTH.ENTER_PWD_LABEL' | translate }}</label>
        <div class="input-wrapper">
            <input id="tokenInput" [type]="changetype ? 'password' : 'text'" #tokenInput placeholder="{{'AUTH.ENTER_PWD' | translate}}" (keydown.enter)="submitToken(tokenInput.value)" />
            <span class="eyeicon" (click)="viewToken()">
                <i [ngClass]="visible ? 'fas fa-eye' : 'fas fa-eye-slash'"></i>
            </span>
        </div>
        <div *ngIf="tokenNotExist" class="error-message">
            {{ 'AUTH.ERROR_TOKEN' | translate }}
        </div>
        <div class="footer-button">
            <button class="submit-button" (click)="submitToken(tokenInput.value)">{{'AUTH.CONFIRM' | translate}}</button>
        </div>
    </div>
</div>